import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type NotificationData } from "~/features/notifications/Messages";
import { type NotificationListResponseDTO, transformNotificationDTO } from "./dto";

export async function fetchLatestNotifications(): Promise<{
  results: NotificationData[];
  totalAmount: number;
}> {
  const url = occUrl("/notifications/last-notifications");
  const response = await occFetch(url);

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const dto = (await response.json()) as NotificationListResponseDTO;
  const results = (dto.notifications ?? []).map(transformNotificationDTO);

  return {
    results,
    totalAmount: 0,
  };
}
